import _firebase from "firebase/app";
import "firebase/auth";
import { config } from "./config";
const FIREBASE_AUTH_EMULATOR_PORT = "9099";
_firebase.initializeApp(config);
export var firebase = _firebase;
import { isTest } from "gather-env-config/dist/src/public/envShared";
export const authObj = firebase.auth;
export const auth = firebase.auth();
if (isTest) {
    auth.useEmulator(`http://127.0.0.1:${FIREBASE_AUTH_EMULATOR_PORT}`);
}
export const User = firebase.User;
//# sourceMappingURL=firebase.js.map